// extracted by mini-css-extract-plugin
export default {"panel":"Balance_panel__6xn1F","header":"Balance_header__RTwsT","headline":"Balance_headline__-tmbu","containerBtns":"Balance_containerBtns__8J+1c"};